module.exports = __webpack_public_path__ + "img/partner_1.bee19e37.png";